import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const JourneyBuilder = lazy(() => import('../components/JourneyBuilder'));
const JourneyBuilderView = lazy(
  () => import('../components/JourneyBuilderView/JourneyBuilderView'),
);
const JourneyBuilderEdit = lazy(
  () => import('../components/JourneyBuilderEdit/JourneyBuilderEdit'),
);
const FromAssignment = lazy(
  () => import('../components/FromAssignment/FromAssignment'),
);

const journeyBuilderRoute: RouteObject[] = [
  {
    path: '/journeys/from-assignment/:id',
    element: <FromAssignment />,
  },
  {
    path: '/journeys/:id',
    element: <JourneyBuilder />,
    children: [
      {
        index: true,
        element: <JourneyBuilderView />,
      },
      {
        path: 'edit',
        element: <JourneyBuilderEdit />,
      },
    ],
  },
];

export default journeyBuilderRoute;
